/** File picker `accept` — PNG, JPG, PDF, Excel and HTML (PROLINE client reports). */
export const CLIENT_REPORT_ACCEPT = ".pdf,.jpg,.jpeg,.png,.xls,.xlsx,.html,.htm";

/** MIME types paired with CLIENT_REPORT_ACCEPT. */
export const CLIENT_REPORT_MIME_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/html",
];

export const CLIENT_REPORT_MAX_SIZE_BYTES = 10 * 1024 * 1024;
export const CLIENT_REPORT_MAX_SIZE_LABEL = "10MB";

export const CLIENT_REPORTS_DEFAULT_PAGE_SIZE = 10;
